/**
 * @module profile/containers/portfolio
 */
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import Portfolio from 'profile/components/portfolio';
import { toggleCollapsed } from 'header/ducks';
import {
  getPortfolio, fetchPortfolioEntries, fetchPortfolioEntriesIfNeeded,
  toggleDetailsMode, setPortfolioDirty, getVisibleEntries, deletePortfolio
} from 'profile/ducks/portfolio';
import {
  toggleEditForm as togglePortfolioEditForm, getPortfolioEditForm,
} from 'profile/ducks/portfolio_form';

Portfolio.need = [
  (params) => fetchPortfolioEntriesIfNeeded(params.profileUsername),
];

function mapStateToProps(state, { params }) {
  return {
    profileUsername: params.profileUsername,
    portfolioState: getPortfolio(state),
    profile: state.profile.view.data,
    user: state.user,
    editForm: getPortfolioEditForm(state),
    visibleEntries: getVisibleEntries(state),
  };
}

function mapDispatchToProps(dispatch, { params }) {
  const actions = {
    fetchPortfolioEntries,
    fetchPortfolioEntriesIfNeeded,
    togglePortfolioEditForm,
    toggleCollapsed,
    toggleDetailsMode,
    setPortfolioDirty,
    deletePortfolio,
  };

  return bindActionCreators(actions, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Portfolio));



// WEBPACK FOOTER //
// ./profile/containers/portfolio.jsx